import { render, staticRenderFns } from "./MatchingProcessItems.vue?vue&type=template&id=b3a99f36"
import script from "./MatchingProcessItems.vue?vue&type=script&lang=js"
export * from "./MatchingProcessItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports